import React, { Fragment } from 'react';
import { Translate } from 'core/translate';
import MathBox from '../../components/mathBox/MathBox';
import { useModelInfo } from '../../common/ModelInfoContext';

export const SHARE_MATH_BOX_ID = 'share-math-box';

const ShareMathBox = props => {
  const { pricing } = props;
  const { incentives, employeePrice, accessoriesTotal } = pricing;
  const { isCanada } = useModelInfo();

  return (
    <div id={SHARE_MATH_BOX_ID} className="show-for-sr">
      <MathBox {...props} />

      {isCanada && employeePrice ? (
        <Fragment>
          <div className="notifications__disclaimer">
            † <Translate value="byo.disclaimer.total.price" />
          </div>
          <div className="notifications__disclaimer">
            ‡ <Translate value="stp.pricing.misc.fee.disclaimer.ehf.tires" />
          </div>
          <div className="notifications__disclaimer">
            * <Translate value="byo.disclaimer.total.employee.price" />
          </div>
          <div className="notifications__disclaimer">
            ^ <Translate value="byo.disclaimer.employee.net.price" />
          </div>
        </Fragment>
      ) : (
        <div className="notifications__disclaimer">
          † {pricing.incentives.disclaimer}
        </div>
      )}
      {accessoriesTotal ? (
        <div className="notifications__disclaimer">
          ‡ <Translate value="byo.page.general.disclaimer.msrp.2" />
        </div>
      ) : null}

      {incentives.lines.map((line, lineIndex) => (
        <div key={lineIndex} className="notifications__disclaimer">
          {line.disclaimers.map((disclaimer, disclaimerIndex) => (
            <div key={disclaimerIndex}>
              {disclaimerIndex === 0 ? (
                <Fragment>
                  <sup>{lineIndex + 1}</sup>{' '}
                </Fragment>
              ) : null}
              <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ShareMathBox;
